module.exports = __webpack_public_path__ + "static/media/Lens-Chic_HK.af68315b.png";